export const MAX_PROJECT_TITLE_LENGTH = 119;
export const MAX_AUTHOR_NAME_LENGTH = 60;
export const MAX_LAYOUT_NAME_LENGTH = 100;
